import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const [adminCode, setAdminCode] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // preluăm URL-ul backend-ului din .env
  const API_URL = process.env.REACT_APP_API_URL;

  const handleAdminLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch(`${API_URL}/admin-login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: adminCode }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Admin login failed");
        return;
      }

      // Salvăm token-ul și rolul în localStorage
      localStorage.setItem("token", data.token);
      localStorage.setItem("role", "admin");

      // Navigăm la dashboard-ul adminului
      navigate("/admin");
    } catch (err) {
      setError("Network error");
      console.error(err);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 border rounded shadow-lg bg-white dark:bg-neutral-900">
      <h2 className="text-2xl font-bold mb-6 text-center">Admin Login</h2>

      {error && <p className="text-red-600 mb-4">{error}</p>}

      <form onSubmit={handleAdminLogin} className="space-y-4">
        <input
          type="password"
          placeholder="Admin Secret Code"
          value={adminCode}
          onChange={(e) => setAdminCode(e.target.value)}
          required
          className="w-full p-2 border rounded"
        />
        <button
          type="submit"
          className="w-full bg-red-600 text-white py-2 rounded hover:bg-red-700"
        >
          Login as Admin
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
